import tabs from '@/components/Shares/Tab.module.css';
import { useLingui } from '@lingui/react';
import { Group, Paper, SimpleGrid, Tabs } from '@mantine/core';
import { GameBattles } from './GameBattles';
import { GameChallenges } from './GameChallenges';
import { GameDescription } from './GameDescription';
import { GameTable } from './GameTable';
export const GameControl: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Paper mt={20} bg="var(--bg-200)">
      <Tabs variant="pills" defaultValue="bigWin" classNames={{
      tab: tabs.tab
    }}>
        <Group justify="center" px={{
        base: 10,
        sm: 20
      }} py={{
        base: 16,
        sm: 20
      }} bg="var(--bg-400)">
          <Tabs.List w={{
          base: '100%',
          sm: 'auto'
        }}>
            <SimpleGrid cols={{
            base: 3,
            sm: 5
          }} spacing={{
            base: 10,
            lg: 20
          }}>
              <Tabs.Tab value="bigWin">{i18n._('Big win')}</Tabs.Tab>
              <Tabs.Tab value="luckyWin">{i18n._('Lucky win')}</Tabs.Tab>
              <Tabs.Tab value="description">{i18n._('Description')}</Tabs.Tab>
              <Tabs.Tab value="battles">{i18n._('Battles')}</Tabs.Tab>
              <Tabs.Tab value="challenges">{i18n._('Challenges')}</Tabs.Tab>
            </SimpleGrid>
          </Tabs.List>
        </Group>

        <Tabs.Panel value="bigWin">
          <GameTable />
        </Tabs.Panel>
        <Tabs.Panel value="luckyWin">
          <GameTable />
        </Tabs.Panel>
        <Tabs.Panel value="description">
          <GameDescription />
        </Tabs.Panel>
        <Tabs.Panel value="battles">
          <GameBattles />
        </Tabs.Panel>
        <Tabs.Panel value="challenges">
          <GameChallenges />
        </Tabs.Panel>
      </Tabs>
    </Paper>;
};